module.exports = __webpack_public_path__ + "27346c97fc3110fff1765976ea3436ae.svg";